import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FormQuestionDeleteOptions } from '../form-question-delete-type';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { FiDialogCloseReason } from '@fi-shared/fi-dialogs/fi-dialogs-close-reason';

@Component({
    selector: 'fi-form-edit-confirm-question-delete-dialog',
    template: `
        <mat-dialog-content>{{ 'delete_question_dialog_text' | fiAppText }}</mat-dialog-content>
        <div class="question-delete-dialog-actions-container">
            <button mat-button (click)="cancel()">{{ 'common.cancel' | fiAppText | uppercase }}</button>
            <button mat-button (click)="close(FormQuestionDeleteOptions.Delete)">
                {{ 'common.question_and_answer_delete' | fiAppText | uppercase }}
            </button>
            <button mat-button class="BrandedColor" (click)="close(FormQuestionDeleteOptions.MarkAsDisabled)">
                {{ 'common.question_disable' | fiAppText | uppercase }}
            </button>
        </div>
    `,
    styleUrls: ['./fi-form-edit-confirm-question-delete-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-form-edit-confirm-question-delete-dialog' },
    standalone: false,
})
export class FiFormEditConfirmQuestionDeleteDialogComponent extends FiDialogsContentBase<
    void,
    FormQuestionDeleteOptions
> {
    readonly FormQuestionDeleteOptions = FormQuestionDeleteOptions;

    close(formQuestionDeleteOptions: FormQuestionDeleteOptions) {
        this.dialogRef.close({
            value: formQuestionDeleteOptions,
            reason: FiDialogCloseReason.YesButton,
        });
    }

    cancel() {
        this.dialogRef.close({
            reason: FiDialogCloseReason.NoButton,
        });
    }
}
